import React from 'react';

import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint, LoadableBackground } from '@confluence/loadable';

import { ReactionsPlaceholder } from './ReactionsPlaceholder.tsx';
import { ReactionsSummaryViewPlaceholder } from './ReactionsSummaryViewPlaceholder.tsx';
import type { ReactionsProps } from './Reactions.tsx';

export const ReactionsLoader: LoadableType<ReactionsProps> = LoadableAfterPaint({
	loading: (props) => {
		return props?.summaryViewEnabled ? (
			<ReactionsSummaryViewPlaceholder />
		) : (
			<ReactionsPlaceholder useAccuratePills {...props} />
		);
	},
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Reactions" */ './Reactions.tsx')).Reactions,
});

export const ReactionsLoaderBackground: LoadableType<ReactionsProps> = LoadableBackground({
	loading: (props) => {
		return props?.summaryViewEnabled ? (
			<ReactionsSummaryViewPlaceholder />
		) : (
			<ReactionsPlaceholder />
		);
	},
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Reactions" */ './Reactions.tsx')).Reactions,
});
